// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14dae85e","453":"64512fd7","732":"34f0231b","977":"6e3054a9"}[chunkId] + ".chunk.js";
};